import React, { useContext, useEffect, useState } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Container,
  Typography,
} from '@mui/material';
import { Banner } from '../Banner';
import { Intro } from '../Intro';
import { PreferencesForm } from '../PreferencesForm';
import { AccountForm } from '../AccountForm';
import { SubmitComplete } from '../SubmitComplete';
import { FormDataContext } from '../../contexts/FormDataContext';
import { AccountSettings } from '../AccountSettings';
import { OccupationsAutocomplete } from '../OccupationsAutocomplete';
import { LocationsAutocomplete } from '../LocationsAutocomplete';
import { AttributesAutocomplete } from '../AttributesAutocomplete';
import { EducationAutocomplete } from '../EducationAutocomplete';
import { UniversityAutocomplete } from '../UniversityAutocomplete';
import { Occupations } from '../Occupations';
import { Attributes } from '../Attributes';
import { University } from '../University';
import { Locations } from '../Locations';
import { Education } from '../Education';

export const VARIANT_INITIAL = 'INITIAL';
export const VARIANT_CURRENT = 'CURRENT';
export const IntakeComponent = ({variant}) => {
  const [messages, setMessages] = useState([]);
  const [intakeVariant] = useState(() => {
    switch (variant) {
      case VARIANT_INITIAL:
        return variant;
      default:
        return VARIANT_CURRENT;
    }
  });

  useEffect(() => {
    fetch('/roa/intake/status-messages')
      .then(response => response.json())
      .then(data => {
        if (data.status) {
          setMessages(data.status); // Assuming 'status' is the key for status messages
        }
      });
  }, []);

  const {
    isSubmitComplete,
    attributesDataLoaded,
    locationDataLoaded,
    occupationDataLoaded,
    schoolDataLoaded,
    intakeDataLoaded,
    degreesDataLoaded,
    isFormCompleted,
    isFormDataLoaded,
    setIsFormDataLoaded,
  } = useContext(FormDataContext);

  useEffect(() => {
    const allFormDataLoaded =
      attributesDataLoaded
        && locationDataLoaded
        && occupationDataLoaded
        && schoolDataLoaded
        && intakeDataLoaded
        && degreesDataLoaded;
    if (allFormDataLoaded) {
      setIsFormDataLoaded(true);
    }
  }, [
    attributesDataLoaded,
    locationDataLoaded,
    occupationDataLoaded,
    schoolDataLoaded,
    intakeDataLoaded,
    degreesDataLoaded
  ]);

  return (
    <Container maxWidth={false} disableGutters={true}>
      <Banner/>
      {messages.length > 0 &&
          <Box textAlign="center" justifyContent="center" display="flex" sx={{margin:"15px 0"}}>
            {messages.map((msg, index) => (
              <Alert
                key={index}
                severity="info"
                onClose={() => {setMessages([])}}
                sx={{maxWidth: "500px", marginTop: "40px"}}
              >
                <Typography dangerouslySetInnerHTML={{ __html: msg }} sx={{fontSize:"1rem"}}/>
              </Alert>
            ))}
          </Box>
      }
      <Container
        maxWidth={!isSubmitComplete ? "md" : "sm"}
        sx={{px: !isSubmitComplete ? {md: "75px"} : ""}}
      >
        {!isSubmitComplete ? <>{!isFormCompleted && <Intro/> }</> : <SubmitComplete/>}
      </Container>
        {!isSubmitComplete &&
          <>
            {isFormDataLoaded
              ?
                <Container maxWidth="sm" sx={{ marginTop: "40px" }}>
                  {isFormCompleted ? <AccountSettings/> : <AccountForm intakeVariant={intakeVariant}/>}
                  <PreferencesForm>
                    {intakeVariant === VARIANT_INITIAL &&
                      <>
                        <Occupations/>
                        <Locations/>
                        <Attributes/>
                        <Education/>
                        <University/>
                      </>
                    }
                    {intakeVariant === VARIANT_CURRENT &&
                      <>
                        <OccupationsAutocomplete/>
                        <LocationsAutocomplete/>
                        <AttributesAutocomplete/>
                        <EducationAutocomplete/>
                        <UniversityAutocomplete/>
                      </>
                    }
                  </PreferencesForm>
                </Container>
              :
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                  }}
                >
                  <CircularProgress sx={{color: 'white'}} />
                  <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    Loading form...
                  </Typography>
                </Box>
            }
          </>
        }
    </Container>
  );
};
